import { getRoomsFromState } from '../../api/onboardingApi';
import { HOTEL_IMAGE_SECTIONS, KYC_IMAGE_SECTIONS } from './onboardingConfig';

function display(v) {
  if (v === undefined || v === null) return '—';
  if (Array.isArray(v)) {
    const joined = v.join(', ');
    return joined.trim() === '' ? '—' : joined;
  }
  if (typeof v === 'boolean') return v ? 'Yes' : 'No';
  if (typeof v === 'string' && v.trim() === '') return '—';
  return v;
}

function roomLine(room) {
  const r = room || {};
  const roomRates = r.occupancyRates && typeof r.occupancyRates === 'object'
    ? Object.entries(r.occupancyRates)
        .filter(([, v]) => v !== '' && v != null)
        .map(([k, v]) => `${k.replace('guest', '')}G ₹${v}`)
        .join(', ')
    : '';
  return [
    r.roomTypeName && `${r.roomTypeName} x ${r.roomCount || 1}`,
    roomRates || null,
    r.maxOccupancy && `Max ${r.maxOccupancy} guests`,
  ].filter(Boolean).join(' • ') || '—';
}

function imagesLine(imageCounts) {
  const counts = imageCounts && typeof imageCounts === 'object' ? imageCounts : {};
  const parts = HOTEL_IMAGE_SECTIONS
    .filter((section) => (counts[section.key] || 0) > 0)
    .map((section) => `${section.label}: ${counts[section.key]}`);
  return parts.length > 0 ? parts.join(' • ') : 'None (add later from Property Images)';
}

function kycImagesLine(kycImageCounts) {
  const counts = kycImageCounts && typeof kycImageCounts === 'object' ? kycImageCounts : {};
  const parts = KYC_IMAGE_SECTIONS
    .filter((section) => (counts[section.key] || 0) > 0)
    .map((section) => `${section.label}: ${counts[section.key]}`);
  return parts.length > 0 ? parts.join(' • ') : '—';
}

export function buildOnboardingSummary(state) {
  const s = state || {};
  const addressParts = [s.address, s.city, s.state, s.country]
    .map((p) => (p == null ? '' : String(p).trim()))
    .filter((p) => p !== '');
  const address = addressParts.length > 0 ? addressParts.join(', ') : '—';

  const rooms = getRoomsFromState(s);
  const roomRows = rooms.length > 0
    ? rooms.map((room, i) => ({
        label: rooms.length > 1 ? `Room Type ${i + 1}` : 'Room Type',
        value: roomLine(room),
      }))
    : [{ label: 'Room Type', value: '—' }];

  return [
    { label: 'Full Name', value: display(s.fullName) },
    { label: 'Account Email', value: display(s.accountEmail) },
    { label: 'Account Phone', value: display(s.accountPhone) },
    { label: 'Property Name', value: display(s.propertyName) },
    { label: 'Property Type', value: display(s.selectedPropertyType) },
    { label: 'Address', value: address },
    { label: 'Pincode', value: display(s.pincode) },
    { label: 'Check-in', value: display(s.checkinTime) },
    { label: 'Check-out', value: display(s.checkoutTime) },
    { label: 'Amenities', value: display(s.selectedAmenities) },
    { label: 'Hotel Policies', value: display(s.selectedHotelPolicies) },
    { label: 'Cancellation Policies', value: display(s.selectedCancellationPolicies) },
    { label: 'Open 24x7', value: display(s.isOpen24x7) },
    { label: 'Couple Friendly', value: display(s.isCoupleFriendly) },
    { label: 'PAN Number', value: display(s.panNumber) },
    { label: 'GST Number', value: display(s.gstNumber) },
    { label: 'Agreed to Policy', value: display(s.agreedToPolicy) },
    { label: 'KYC Photos', value: kycImagesLine(s.kycImageCounts) },
    ...roomRows,
    { label: 'Images', value: imagesLine(s.imageCounts) },
  ];
}
